// Keeps the bracket page's goal widget current.
//
// The widget shows prefs.goalInfo, a saved copy of the pinned goal's progress. Only the
// profile page used to write it, so after winning a title you still needed, the bracket
// page kept asking for it until you happened to open your own profile. The bracket page
// now rebuilds the copy itself whenever a newer data build is out. The copy records
// which build it came from (goalInfo.src: the manifest keys of the files it was
// computed from), so while nothing new is published, a check costs one small manifest
// read. The math is the profile's own (goals.js), so the two can't disagree.
import { latestManifest, loadFile } from './dataStore.js';
import { buildClassAgg, monsterClasses, humanClasses, playerFromRecord, bettingFor } from './playerHelpers.js';
import { playerQuests, carriedByMonsters, goalSnapshot } from './goals.js';
import { achievementsFull } from './achievements.js';
import { resolvePlayerName } from './resolvePlayerName.js';
import migrations from '../data/nameMigrations.json';

// The saved copy rebuilt from the newest data: a goalInfo object, or null when the goal
// no longer exists. undefined = leave the saved copy alone (it's current, there's no
// goal, or the data can't be read right now).
export async function freshGoalInfo(prefs) {
  const goal = prefs.activeGoal;
  if (!goal || !prefs.myUsername) return undefined;
  const m = await latestManifest();
  if (!m || !m.files) return undefined;
  const quest = goal.type === 'quest';
  // Only Carried by Monsters reads champHistory, and only achievements read the betting file.
  const names = ['playerIndex.json', quest && goal.id === 'carried' ? 'champHistory.json' : null, quest ? null : 'bettingStats.json'];
  const keys = names.map((n) => n && m.files[n]);
  if (keys.some((k, i) => names[i] && !k)) return undefined;
  const src = keys.filter(Boolean).join(' ');
  if (prefs.goalInfo && prefs.goalInfo.src === src) return undefined;

  const [index, history, betting] = await Promise.all(keys.map((k) => (k ? loadFile(k) : null)));
  const { canonical, record } = resolvePlayerName(prefs.myUsername, index, migrations.alias);
  if (!record) return undefined;
  const player = playerFromRecord(canonical, record);
  const classAgg = buildClassAgg(Object.values(index)), mon = monsterClasses(classAgg);
  const quests = quest ? playerQuests(player, { monsterClasses: mon, humanClasses: humanClasses(classAgg), classAgg, carried: history && carriedByMonsters(history, canonical, mon) }) : [];
  const achievements = quest ? [] : achievementsFull(player, mon, betting && bettingFor(betting, canonical));
  const info = goalSnapshot(goal, quests, achievements);
  return info && { ...info, src };
}
